import React from "react";
import { StarIcon as StarSolid } from "@heroicons/react/24/solid";
import { StarIcon as StarOutline } from "@heroicons/react/24/outline";

// Shared between the review form (interactive — pass onChange), the
// customer-facing tradesman profile, and the tradesman's own profile pages
// (both read-only — omit onChange).
const StarRating = ({ value, onChange, size = "h-5 w-5" }) => {
  const interactive = typeof onChange === "function";
  const rounded = Math.round(value || 0);

  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => {
        const Icon = n <= rounded ? StarSolid : StarOutline;
        return interactive ? (
          <button
            key={n}
            type="button"
            onClick={() => onChange(n)}
            className="text-yellow-400"
            aria-label={`${n} star${n === 1 ? "" : "s"}`}
          >
            <Icon className={size} />
          </button>
        ) : (
          <Icon key={n} className={`${size} text-yellow-400`} />
        );
      })}
    </div>
  );
};

export default StarRating;
